import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/employer');

const EmployerFxs = {
    getEmployerByDomainFx: domain.effect(api.employer.getEmployerByDomain),
    sendCodeFx: domain.effect(api.employer.sendCode),
    linkEmployeeFx: domain.effect(api.employer.linkEmployee),
    linkDiscounterFx: domain.effect(api.employer.linkDiscounter),
    checkCodeValidityFx: domain.effect(api.employer.checkCodeValidity),
};

export default EmployerFxs;
